<template>
  <div class="class">
    <class-head :updateMark="updateMark" :subjectArr="subjectArr" @toolShow='toolShow' :tabGuideShow="tabGuideShow" @hideTabGuide="hideTabGuide"></class-head>
<!--    <div v-if="memberStatus == 4" class="whl-member-expiration">-->
<!--      <p>会员服务已过期</p>-->
<!--      <p>请在微信中搜索并关注【狸米新启航】公众号，开通会员后再来学习吧~</p>-->
<!--    </div>-->
    <class-list
      v-if="isShowClass"
      @getListSuccess="getListSuccess"
      :lessonIndex='lessonIndex'
      :subjectIndex='subjectIndex'
      :gradeIndex='gradeIndex'
      :classYear="classYear"
      :semesterIndex='semesterIndex'
      :guideShow="guideShow"></class-list>
    <div class="tool_mask" v-show="toolisShow" @click="toolisShow=false"></div>
    <transition name="slide">
      <tool @checkLessonType="checkLessonType" @toolShow='toolShow' v-show="toolisShow" :classYears="classYears" :classGrades="classGrades"></tool>
    </transition>
    <update-version v-if="a_update" :datas="upDatas"></update-version>
    <announce v-if="b_announce" :datas="announceData"></announce>
    <badge-box v-if="c_badgeBox" :datas="badegeList"></badge-box>
    <icp />
    <alert
      :sameTwo="alertText"
      :btn="'我知道了'"
      :show="isCanPlay"
      @ensure="iKnow"
    ></alert>
  </div>
</template>

<script>
import class_head from "./class_head";
import tool from "./tool";
import class_list from "./class_list";
import badge_box from "../badgeBox/badgebox";
import update_version from "../../basic/updateversion";
import announce from "../../basic/announce.vue";
import icp from "@/components/basic/icp.vue";
import alert from "@/components/basic/alert.vue";
import common from "common";
import utils from "utils";
import { mapState, mapMutations, mapActions } from "vuex";
if (LIMI_ENV === "electron") {
  var ipc = window.require("electron").ipcRenderer;
}
export default {
  name: "class",
  data() {
    return {
      alertText: '出错了，请稍后重试~',
      isCanPlay: false,
      updateMark: false, //小游戏入口红点
      // already_Guide: false,
      badegeList: [],
      classYears: [],
      classGrades: [],
      upDatas: {},
      announceData: {},
      a_update: false,
      b_announce: false,
      c_badgeBox: false,
      guideShow: false,
      checkWindow: {
        guideShow:0,
        a_update: 0,
        b_announce: 0,
        c_badgeBox: 0,
      },
      subjectIndex:'',
      gradeIndex:'',
      lessonIndex:'',
      classYear: '',
      semesterIndex: '',
      toolisShow:false,
      isShowClass: false,
      subjectArr: [],
      tabGuideShow: false
    };
  },
  components: {
    "class-head": class_head,
    "class-list": class_list,
    "update-version": update_version,
    "badge-box": badge_box,
    announce,
    tool,
    icp,
    alert
  },
  watch: {
    checkWindow: {
      deep: true,
      handler(newV) {
        if(newV.guideShow == 0) return;
        if(newV.guideShow==1){
          this.showPopup();
        }else if (newV.a_update == 1) {
          this.showPopup();
        } else {
          if (newV.a_update == 0) {
          } else {
            let flag = true;
            for (let x in newV) {
              if (newV[x] == 0) {
                flag = false;
                break;
              }
            }
            if (flag) this.showPopup();
          }
        }
      }
    }
  },
  computed: {
    ...mapState(["userID","phone","firstLogin","lastGrade","memberStatus"])
  },
  created() {
    this.checkWindow.guideShow = this.firstLogin ? 0 : 2;
    this.$root.eventHub.$on("showPopup", type => {
      this[type] = false;
      switch (type) {
        case "guideShow":
          this.guideShow = false;
          this.saveFirstLogin(2);
          break;
        case "a_update":
          this.upDatas = {};
          break;
        case "b_announce":
          this.announceData = {};
          break;
        case "c_badgeBox":
          this.badegeList = [];
          break;
      }
      setTimeout(() => {
        this.checkWindow[type] = 3;
      }, 500);
    });
    // 学科tab引导
    let tabGuideShow = common.get('tabGuideShow');
    if(tabGuideShow == null) {
     common.set('tabGuideShow', true);
     tabGuideShow = true;
    }
    this.tabGuideShow = tabGuideShow;
  },
  mounted() {
    if (this.$route.params.from === "first" && LIMI_ENV==="electron") {
      //判断当前平台是否需要进行升级接口请求
      this.updateVersion();
    } else {
      this.checkWindow.a_update = 2;
      //非pc平台不需要进行接口查询，直接显示下一个窗口
    }
    this.getClassPageBaseData({data:{
      client:common.client,
      version: common.version,
      username:this.phone,
      deviceId: utils.createLoginDeviceId(this.phone)
    }}).then(({ res, ok }) => {
      if (ok) {
        // 不同设备互踢
        let deviceId = res.studentInfo.deviceId;
        if(deviceId && deviceId != common.get('login_deviceid')) {
          this.alertText = '您的账号已在其他设备上登录使用，请重新登录';
          this.isCanPlay = true;
          return;
        }
        if (res.badge && res.badge.list && res.badge.list.length > 0) {
          this.badegeList = res.badge.list;
          this.checkWindow.c_badgeBox = 1;
        } else {
          this.checkWindow.c_badgeBox = 2;
        } //首页徽章展示
        const maps = common.get("gamelist") || {};
        let kejianGameList = res.courseWareGame.list[this.lastGrade];
        this.updateMark = kejianGameList.some(item => {
          return item.version != maps[item.folder];
        });
        common.setSession('randerGameList',res.courseWareGame)

        if (res.noticeList && res.noticeList[0] && res.noticeList[0].id) {
          this.getNoticeInfo(res.noticeList[0]);
        } else {
          this.checkWindow.b_announce = 2;
        }
        this.isShowClass = true;
      } else {
        this.checkWindow.c_badgeBox = 2;
        this.checkWindow.b_announce = 2;
      }
    });
  },
  methods: {
    ...mapActions(["getClassPageBaseData", "getLatestVersion"]),
    ...mapMutations(["saveFirstLogin","resetState"]),
    // closeGuide() {
    //   fs ? utils.setNodeStorge("already_Guide", true) : common.set("already_Guide", true);
    //   this.already_Guide = true;
    // },
    hideTabGuide() {
      this.tabGuideShow = false;
      common.set('tabGuideShow', false);
    },
    iKnow() {
      this.resetState();
      this.$router.replace("/login");
      this.isCanPlay = false;
    },
    getListSuccess(){
      this.checkWindow.guideShow = 1;
    },
    getClassList(res, subjectArr) {
      let classYears = res.map(v => v.experienceSubType == 26 ? '' : v.classYear).filter(v => v != '')
      let classGrades = res.map(v => v.experienceSubType == 26 ? '' : v.grade == 32 ? 31 : v.grade).filter(v => v != '')
      this.classGrades = [0].concat([...new Set(classGrades)])
      this.classYears = ['全部年份'].concat([...new Set(classYears)].sort((a,b) => a-b))
      this.subjectArr = subjectArr;
    },
    checkLessonType(gradeIndex, lessonIndex, subjectIndex, classYear, semesterIndex) {
      //筛选班级列表
      this.gradeIndex = gradeIndex;
      this.lessonIndex = lessonIndex;
      this.subjectIndex = subjectIndex;
      this.classYear = classYear;
      this.semesterIndex = semesterIndex
    },
    toolShow(show){
      this.toolisShow = show;
    },
    showPopup() {
      for (let x in this.checkWindow) {
        if (this.checkWindow[x] == 1) {
          this[x] = true;
          break;
        }
      }
    },

    getNoticeInfo(data) {
      let getStorage;
      let setStorage;
      if (data.showType == "1") {
        //localStorage存储
        getStorage = "get";
        setStorage = "set";
      } else if (data.showType == "2") {
        //SessionStorage存储
        getStorage = "getSession";
        setStorage = "setSession";
      } else {
        console.error(`showType is Error : ${data.showType}`);
        this.checkWindow.b_announce = 2;
        return;
      }
      let announce_id = common[getStorage]("announce_id");
      if (announce_id != data.id) {
        common[setStorage]("announce_id", data.id);
        this.announceData = JSON.parse(JSON.stringify(data));
        this.checkWindow.b_announce = 1;
      } else {
        this.checkWindow.b_announce = 2;
      }
    },
    updateVersion() {
      let updateCancel = window.localStorage.getItem("updateCancel");
      this.getLatestVersion({
          platform: common.device,
          version: common.version,
          uid: this.userID
        }).then(({ res, ok }) => {
          if (!ok) {
            this.checkWindow.a_update = 2;
            return;
          }
          if (updateCancel) {
            window.localStorage.removeItem("updateCancel");
            this.checkWindow.a_update = 2;
            return;
          }
          if (res.update && LIMI_ENV === "electron") {
            //需要显示升级窗口
            if (res.isShow == 1) {
              this.upDatas = res;
              this.checkWindow.a_update = 1;
            } else {
              this.checkWindow.a_update = 2;
            }
          } else {
            //不需要显示升级窗口
            this.checkWindow.a_update = 2;
          }
        },
        () => {
          this.checkWindow.a_update = 2;
        }
      );
    }
  }
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.class {
  width: 100%;
  height: 100%;
  background: url("/static/img/class/bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow:hidden;
  position:relative;
  .whl-member-expiration {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    margin-top: -150px;
    &>p:first-child {
      font-size: 32px;
      font-weight: bold;
      opacity: .75;
    }
    &>p:nth-child(2) {
      font-family: PingFang_Medium;
      font-size: 18px;
      margin-top: 20px;
    }
  }
}
.tool_mask{
  position: absolute;
  z-index: 101;
  top: 0;
  left:0;
  width:100%;
  height:100%;
  background:rgba(0,0,0,.5);
}
.slide-enter-active {
  animation: slideLift 0.7s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.slide-leave-active {
  animation: slideLift 0.7s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/class/class.vue